import Seo from "../../components/Seo";
import DepartmentsOverview from "./sections/DepartmentsOverview";
import Hero from "./sections/Hero";
import JobOpenings from "./sections/JobOpenings";
import LifeAtCompany from "./sections/LifeAtCompany";
import RecruitmentProcess from "./sections/RecruitmentProcess";
import SubmitResume from "./sections/SubmitResume";
import WhyWorkWithUs from "./sections/WhyWorkWithUs";
import WorkplaceCulture from "./sections/WorkplaceCulture";

const CareersPage = () => {
  return (
    <>
      <Seo
        title="Careers | Burj Al Yarmouk Industries LLC"
        description="Explore exciting career opportunities at Burj Al Yarmouk Industries LLC. Join our team of engineering, fabrication, and industrial experts in Abu Dhabi and grow your career with us."
        url="https://burjalyarmouk.com/careers"
        image="https://burjalyarmouk.com/og-banner.jpg"
        keywords="Burj Al Yarmouk careers, fabrication jobs UAE, engineering jobs Abu Dhabi, steel fabrication careers, generator enclosure jobs, industrial engineering vacancies UAE"
        schema={{
          "@context": "https://schema.org",
          "@type": "JobPosting",
          title: "Careers at Burj Al Yarmouk Industries LLC",
          description:
            "Join Burj Al Yarmouk Industries LLC and explore career opportunities in engineering, fabrication, steel structures, and industrial manufacturing.",
          hiringOrganization: {
            "@type": "Organization",
            name: "Burj Al Yarmouk Industries LLC",
            sameAs: [
              "https://www.instagram.com/burjalyarmouk/",
              "https://www.linkedin.com/in/burj-al-yarmouk-industries-llc-417570347/",
            ],
            logo: "https://burjalyarmouk.com/favicon.ico",
            url: "https://burjalyarmouk.com/",
          },
          employmentType: "FULL_TIME",
          jobLocation: {
            "@type": "Place",
            address: {
              "@type": "PostalAddress",
              addressLocality: "Abu Dhabi",
              addressCountry: "UAE",
            },
          },
          applicantLocationRequirements: {
            "@type": "Country",
            name: "United Arab Emirates",
          },
        }}
      />

      <Hero />
      <JobOpenings />
      <WhyWorkWithUs />
      {/* <EmployeeBenefits /> */}
      <LifeAtCompany />
      <RecruitmentProcess />
      {/* <PortfolioShowcase /> */}
      <DepartmentsOverview />
      <WorkplaceCulture />
      {/* <MediaGallery /> */}
      <SubmitResume />
    </>
  );
};

export default CareersPage;
